export const it = {
  ADD_COLOR_STRING_KEY: 'Aggiungi colore',
  ADD_TEXT_KEY: 'Aggiungi testo',
  ADD_TO_ORDER_KEY: "Aggiungi all'ordine",
  ADD_TO_CART: 'Aggiungi al carrello',
  ADD_TEMPLATE: 'Aggiungi modello',
  ADJUST_SIZE_KEY: 'Regola dimensione',
  ADJUST_TRANSPARENCY_KEY: 'Regola la trasparenza',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "Facendo clic su Fine, dichiari di accettare i termini d'uso e l'informativa sulla privacy di HP.",
  ALIGN_BOTTOM_KEY: 'Allinea in basso',
  ALIGN_CENTER_KEY: 'allinea al centro',
  ALIGN_KEY: 'allineare',
  ALIGN_LEFT_KEY: 'inizio',
  ALIGN_MIDDLE_KEY: 'allineare il centro',
  ALIGN_RIGHT_KEY: 'fine',
  ALIGN_TOP_KEY: 'Allinea in alto',
  ALL_TAB_TITLE_KEY: 'Tutti',
  ALMOST_DONE_TITLE_KEY: 'Quasi finito!',
  AND_KEY: 'e',
  APPLY_KEY: 'Applica',
  AREA_CODE: 'Prefisso',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Sfoglia il contenuto e seleziona le immagini per il tuo progetto, oppure carica le tue',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Visualizza in anteprima il tuo progetto o metti a punto i dettagli',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Personalizza il progetto e aggiungi altri elementi al tuo progetto',
  BASIC_HELPER_INSTRUCTION4_KEY:
    "Quando il progetto è pronto, fai clic su AVANTI per eseguire un controllo finale ed effettuare l'ordine.",
  BACK_KEY: 'Indietro',
  BACKGROUND_KEY: 'Sfondo',
  BACKGROUND_UPPER_CASE_KEY: 'SFONDO',
  BACKGROUND_CONTRAST_KEY: 'Contrasto sfondo',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Nessuna ispirazione trovata in questa categoria',
  BRING_TO_FRONT_KEY: 'Porta in primo piano',
  CANCEL_TEXT_KEY: ' Annulla ',
  CENTIMETERS_KEY: 'centimetri',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Cambia le impostazioni del tuo progetto',
  CHECKBOX_CONTENT1: 'Voglio ricevere la newsletter di Pattern Design ©',
  CHECKBOX_CONTENT2:
    'Autorizzo HP a creare un account nei servizi di Pattern Design © per mio conto',
  CHOOSE_FROM_COMPUTER_KEY: 'Scegli dal computer',
  CHOOSE_RIP_OPTIONS: 'Scegli uno di questi RIP di terzi compatibili',
  CHOOSE_FILE_KEY: 'Scegli file',
  CITY: 'Città',
  CLEAR_ALL_KEY: 'Cancella tutto',
  CLEAR_COLOR_KEY: 'Cancella colore',
  CLOSE_WINDOW_KEY: 'Chiudi finestra',
  CLEAR_ALL_OBJECTS: 'Cancella tutti gli oggetti',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'In questo modo, tutti gli oggetti verranno rimossi dallo sfondo.',
  CLEAR_DESIGN_KEY: 'Cancella progetto',
  COLOR_KEY: 'Colore',
  CONTINUE_KEY: 'Avanti...',
  COMPANY: 'Azienda',
  CONGRATULATIONS_KEY: 'Complimenti!',
  CONFIRM_PASSWORD: 'Conferma password',
  CONFIRM_PATTERN_ACCOUNT_KEY: 'Non hai ancora un account Pattern Design?',
  CONFIRM_VECTEEZY_ACCOUNT_KEY: 'Non hai ancora un account Vecteezy?',
  COUNTRY: 'Nazione',
  CREATE_ACCOUNT: 'Creare un profilo',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Costume',
  CUSTOM_PRICE_SIGN_IN_KEY:
    'Accedi al prossimo passaggio per vedere i prezzi personalizzati.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Crea nuovo',
  DESIGN_KEY: 'Progetto',
  DELETE_KEY: 'Elimina',
  DOCUMENT_COLORS: 'Colori del documento',
  DONE: 'Fine',
  DONE_KEY: 'Fine',
  DONT_SHOW_ALERT_KEY: 'Non mostrare più',
  DOWNLOAD_COLUMN_HEADER_KEY: 'Scarica',
  DOWNLOAD_APP_TITLE_KEY: "Scarica l'app qui:",
  DOWNLOAD_LINK_KEY: 'Scarica HP Click gratis qui',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Scarica HP SmartStream',
  DOWNLOAD_INSTR_KEY:
    'Prima di proseguire, accertati che HP Click sia installato',
  DOWNLOAD_SMARTSTREAM_KEY: 'Scarica HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Importazione Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    "La dimensione dell'immagine deve essere inferiore a 1 GB. Accettiamo i formati pdf, png, jpg e tiff.",
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Ricerca di Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Immagini di Dreamstime',
  DUPLICATE_KEY: 'Duplica',
  EACH_ITEM_PRICE_KEY:
    'Il tuo progetto include contenuti di uno dei nostri fornitori di contenuti premium. Il prezzo in dettaglio di ogni elemento è sintetizzato di seguito.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Modifica progettazione',
  EDIT_LOWERCASE_KEY: 'modifica',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Si è verificato un errore. Riprova più tardi.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    "Errore durante l'apertura del file PDF caricato.",
  EMAIL_KEY: 'E-mail',
  EMAIL_ADDRESS_KEY: 'Indirizzo e-mail:',
  EMAIL_CHECKBOX_MESSAGE:
    'So che questa persona è consapevole che riceverà delle e-mail da HP per mio conto o da questo fornitore di servizi.',
  EXTRA_INFO_KEY: 'Informazioni aggiuntive',
  EMAIL_NOTIFICATION:
    "A breve verrà inviata un'e-mail. L'elaborazione può richiedere fino a 15 minuti.",
  EMAIL_DIALOG_MESSAGE:
    "Digita l'indirizzo e-mail della persona con cui vuoi condividere il progetto.",
  ENTER_KEY: 'Entra',
  EXISTING_FOLDER_KEY: 'Cartella esistente',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Prima di procedere al completamento del pagamento, verificare che tutti gli elementi selezionati siano corretti',
  FINAL_CHECK_TITLE_KEY: 'Controllo finale',
  FINISH_KEY: 'Fine',
  FINISH_LATER_KEY: 'Finisci più tardi',
  FIRSTNAME: 'nome di battesimo',
  FISCAL_NUM: 'Numero fiscale',
  FLIP_KEY: 'Capovolgi',
  FOR_KEY: 'per',
  FORGOT_PASSWORD_KEY: 'Password dimenticata?',
  FOTOLIA_KEYWORDS_KEY: 'Parole chiave:',
  FOLDER_NAME: 'Nome cartella',
  FOLDER_NAME_KEY: 'Nome cartella:',
  FOLDER_ALREADY_EXIST_KEY: 'Nome della cartella già esistente',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    'Hai appena completato il tuo progetto di poster gratuito',
  FREE_VECTOR_GRAPHICS_KEY: 'grafica vettoriale gratis',
  GETTY_IMAGE_SEARCH_TITLE: 'Cerca Getty Image',
  GOT_IT_MESSAGE_KEY: 'Ho capito',
  GROUP_ALL_KEY: 'Raggruppa tutto',
  GROUP_SCALE: 'Ridimensionamento gruppo',
  GIFT_WRAPS_KEY: 'Confezioni regalo',
  GIVE_PROJECT_NAME_KEY: 'Assegna un nome al progetto',
  HEIGHT_KEY: 'Altezza',
  TOUR_DESCRIPTION_TEXT:
    "Lasciati guidare attraverso il processo di progettazione. Ricorda che puoi riaprire il tour in qualsiasi momento facendo clic sull'icona della guida.",
  HELP_KEY: 'Guida',
  HELPER_TITLE_KEY_1:
    'Crea poster design da una pagina vuota o da milioni di immagini e testo. Carica i tuoi contenuti da unità locali, Dropbox o social media',
  HELPER_TITLE_KEY_3:
    'Guarda tutti i tuoi lavori di progettazione in un unico posto',
  HELPER_TITLE_KEY_4:
    "Fare clic su Avanti per visualizzare l'anteprima e completare il progetto finale",
  HERE_KEY: 'qui',
  HELP_IMPROVE_KEY:
    "Contribuisci a migliorare la produttività e l'efficienza dell'operatore ed espandi la tua attività con la produzione a colori.",
  HIGH_QUALITY_KEY: 'Alta qualità',
  IMAGES_TITLE_KEY: 'Immagini',
  IMPERIAL_KEY: 'Imperiale',
  IMPORTING_KEY: 'Importazione in corso',
  INCHES_COLUMN_HEADER_KEY: 'Pollici',
  INCHES_KEY: ' pollici',
  INCHES_UNIT_STRING_KEY: 'pollici.',
  INVALID_EMAIL_ADDRESS_KEY: 'Indirizzo e-mail non valido',
  INVALID_INFO_KEY: 'Inserisci i dettagli.',
  INVALID_NAME_KEY: 'Nome non valido',
  INVALID_PRINTER_MODEL_KEY: 'Modello stampante non valido',
  INVALID_SERIAL_NUMBER_KEY: 'Numero seriale non valido',
  INAVLID_USER_TYPE_KEY: 'Tipo di utente non valido',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Il file selezionato è troppo grande. La dimensione massima è 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Crediti insufficienti',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Ispirazione',
  I_STOCK_SEARCH_TITLE: 'Cerca iStock',
  INVALID_FILETYPE_ERROR_TEXT:
    'Il formato del file non è valido. Possiamo gestire solo pdf, jpg, png, svg e tif.',
  LANDSCAPE_KEY: 'Orizzontale',
  LANGUAGE_LABLE_KEY: 'Lingua',
  LASTNAME: 'Cognome',
  LEARN_MORE: 'Per ulteriori informazioni',
  LEARN_THE_BASICS_KEY: 'Apprendi le nozioni fondamentali',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Utilizzando questo sito accetti di rispettare questi',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Questo sito web è conforme a',
  LEGAL_FOOTER_MESSAGE3_KEY: 'e a',
  LENGTH_STRING_IN_INCHES_KEY: 'pollici',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'cambia',
  LINK_READER_APP_KEY: 'App LinkReader',
  LINK_READER_APP_DESCRIPTION_KEY:
    "Per visualizzare il contenuto in fase di aggiunta, scarica l'app LinkReader.",
  LOADING_KEY: 'Caricamento in corso...',
  LOADING_TEMPLATE_KEY: 'Caricamento del modello',
  LOGIN_NOW: 'Accedi ora',
  LOCK_KEY: 'Blocca',
  LOGIN_KEY: 'Accesso',
  LOGIN_PATTERN_DESIGN_KEY: 'Accesso alla progettazione di motivi',
  LOGIN_SUBTITLE_KEY:
    'Accedi per vedere i prezzi personalizzati e i dettagli di pagamento',
  LOGIN_VECTEEZY_KEY: 'Accesso a Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Accedi al Dreamstime ',
  LOGOUT_KEY: 'Disconnessione',
  MATERIAL_TITLE_KEY: 'MATERIALE',
  MATERIAL_STRING_KEY: 'Materiale',
  MEASUREMENT_KEY: 'Misura',
  METRIC_KEY: 'Metrico',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Modello',
  MORE_INFO_TEXT_KEY: 'Ulteriori informazioni',
  MY_GIFTWRAPS_KEY: 'I miei pacchetti regalo',
  MY_WORK_KEY: 'Lavoro personale',
  MY_WORK_SAVE_KEY:
    'Il tuo disegno è stato salvato nel tuo spazio Il mio lavoro',
  NAME_KEY: 'Nome:',
  NEXT_BUTTON_TITLE_KEY: 'Avanti',
  NEW_FOLDER_KEY: 'Nuova cartella',
  NO_SHADOW_KEY: 'Nessuna ombreggiatura',
  OBJECT_QUANTITY_KEY: 'Quantità',
  OBJECTS_UPPER_CASE_KEY: 'OGGETTI',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Ordina un campione',
  ORDER_SAMPLE: 'Ordina un campione',
  ORDER_SAMPLE_INFOLABEL_1:
    'Seleziona la porzione di immagine che vuoi ordinare come campione',
  ORDER_SAMPLE_INFOLABEL_2:
    "Riceverai un'e-mail con una vista ravvicinata del tuo progetto a grandezza naturale",
  ORDER_SAMPLE_INFOLABEL_3:
    'Questo permette di valutarne la qualità e la risoluzione',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Ordina subito un campione',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    "Ricevi un'e-mail contenente una vista ravvicinata del tuo progetto nelle sue dimensioni reali per valutarne la qualità/risoluzione.",
  ORIENTATION_KEY: 'Orientamento',
  OTHER_PRINTING_OPTIONS: 'Altre opzioni di stampa',
  PASSWORD_KEY: 'Password',
  PATTERN_COLOR_KEY: 'Colore motivo',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'motivi per',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'Impossibile generare il file PDF. Riprova.',
  PHOTOS_KEY: 'FOTO',
  PHOTO: 'foto',
  PHONE: 'Telefono',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Detengo il copyright di questa immagine e accetto le',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    "La dimensione dell'immagine deve essere inferiore a 500 MB. Accettiamo i formati png, jpg, tiff, svg e tiff.",
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Inserisci il testo qui ...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'ad es. alcune importanti informazioni da comunicare al laboratorio di stampa',
  PLACEHOLDER_INCHES_STRING_KEY: 'pollici',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'Il mio poster',
  PORTRAIT_KEY: 'Verticale',
  POSITION: 'Posizione',
  PREMIUM_IMAGES_TITLE_KEY: 'Immagini premium:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Salva il progetto',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Il progetto contiene modifiche che devono essere salvate prima di continuare.',
  PRICE_COLUMN_HEADER_KEY: 'Prezzo',
  PRINTER_SERIAL_NUMBER_KEY: 'Numero di serie della stampante*',
  PRINTING_ENABLE_DETAILS_KEY:
    'Per consentire la stampa abbiamo bisogno solo di qualche dettaglio in più',
  PRINTER_MODELS_KEY: 'Modelli di stampante*',
  PROCESSING_KEY: 'Elaborazione in corso...',
  PROCESSING_ALERT_TXT:
    'Non chiudere questa finestra mentre elaboriamo il tuo progetto',
  PROCESSING_ALERT_TXT2:
    "Una volta completata l'elaborazione, HP Click si aprirà automaticamente e inizierà a scaricare il file",
  PROCESSING_DONE: 'Hai quasi finito!',
  PROCESSING_FILE_TXT: "È in corso l'elaborazione del file.",
  PROCESSING_TIME_TXT:
    "Ciò potrebbe richiedere un po' di tempo, dato che stiamo componendo la tua creazione per garantire la migliore qualità dell'immagine",
  PROCESSING_ALERT_TXT3:
    'Il file PDF verrà scaricato automaticamente sul tuo computer',
  PROCESSING_ALERT_TXT4:
    "Ricorda che puoi configurare la connessione JDF per l'automazione nelle impostazioni",
  PREMIUM_CONTENT_KEY: 'Contenuto Premium',
  PREVIEW_KEY: 'Anteprima',
  PROFESSIONAL_USE_TITLE_KEY: 'utilizzo professionale.',
  PROJECT_NAME_KEY: 'Nome progetto',
  PROJECT_NAME: 'Nome progetto:',
  PROJECT_ALREADY_EXIST_KEY: 'Nome del progetto già esistente',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Nome del progetto già esistente',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Nome della cartella già esistente',
  PIXELATION_WARNING_KEY: 'Avviso pixel',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    "A causa della risoluzione della tua foto caricata, la tua pelle potrebbe essere distorta o distorta. Per assicurarti che non ci siano sfocature, carica un'immagine di buona qualità ed evita l'allargamento dell'immagine. Se sei soddisfatto dell'anteprima e desideri procedere, continua a inviare.",
  REGISTER_CONTACTINFO: 'In\r\n    \toni sui contatti',
  REGISTER_INFO: 'Registra informazioni',
  REGISTER_PATTERNSUB1: 'Come cliente di valore HP,',
  REQUIRED_FIELDS_KEY: 'Campi obbligatori',
  REQUIRED_FIELDS_TEXT_KEY: 'Campi obbligatori',
  REQUIRED_STRING_KEY: 'OBBLIGATORIO',
  RECOLOR_KEY: 'Ricolora',
  RADICALLY_SIMPLE_KEY: 'Software di stampa estremamente semplice',
  RIPSELECTION_HEAD:
    'Questa è la tua prima volta, seleziona il software di stampa compatibile che preferisci',
  RIPSELECTION_DESC:
    "La selezione diventerà il percorso predefinito dell'opzione di stampa per le stampe future. Le modifiche possono essere apportate in un secondo momento nelle impostazioni",
  REGISTER_COMPANYINFO: 'Informazioni aziendali',
  REGISTER_KEY: 'Registrati',
  REGISTER_NOW: 'Registrati ora',
  REOLOR_KEY: 'Ricolora',
  REQUEST_SAMPLE_KEY: 'Richiedi un campione',
  RESIZE_KEY: 'Ridimensiona',
  RESIZE_ARBITRARILY_KEY: 'Ridimensiona in modo arbitrario',
  RESIZE_PROPORTIONALLY_KEY: 'Ridimensiona mantenendo le proporzioni',
  REVIEW_AND_SUBMIT_KEY: 'Rivedi e invia',
  REQUEST_FOR_QUOTATION: 'Richiesta di preventivo',
  RIGHT_LOGO_TEXT_KEY: 'di',
  ROTATE_KEY: 'Ruota',
  ROTATE_LEFT_KEY: 'Ruota di 90° a sinistra',
  ROTATE_RIGHT_KEY: 'Ruota di 90° a destra',
  ROTATION_KEY: 'Rotazione',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Righe e colonne',
  ROYALTY_FREE_KEY: "esente da diritti d'autore",
  ROYALTY_KEY: 'reali',
  SALUTATION: 'Saluto',
  SAVE_KEY: 'Salva',
  SAVING_KEY: 'Salvataggio in corso...',
  SAVE_INSPIRATION: 'Salva ispirazione',
  SAVE_TEMPLATE: 'Salva modello',
  SAVE_DIALOG_TITLE: 'Salva il progetto',
  SAVE_PROJECT_NAME_KEY: 'Prima di tutto salva il tuo progetto',
  SAVEDIALOG_MESSAGE:
    "Effettua l'accesso per salvare il tuo progetto.Se non hai un account, ti aiuteremo a crearne uno. I tuoi progressi non andranno persi.",
  SEAMLESS_KEY: 'senza soluzione di continuità',
  SCALE_INFO_STRING_KEY:
    "Ridimensiona l'immagine per adattarla al tuo progetto",
  SCALE_KEY: 'Ridimensiona',
  SCALE_ALL_KEY: 'Ridimensiona tutto',
  SCALE_TO_FILL_KEY: 'Riempi',
  SEARCH_BUTTON_TITLE_KEY: 'Cerca',
  SELECT_CUSTOM_SIZE_KEY: 'Seleziona dimensioni personalizzate',
  SELECT_CUSTOM_KEY: 'Costume',
  SEARCH_TITLE: 'Cerca',
  SELECTED_IMAGE_KEY: 'Immagine selezionata:',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Seleziona le dimensioni degli involucri regalo',
  SELECT_COUNTRY: 'Seleziona il paese',
  SELECT_SALUTATION: '---Selezionare---',
  SELECT_POSTER_SIZE_KEY: 'Seleziona la dimensione del poster',
  SELECT_PRINTING_OPTION_KEY: 'Scegli la tua opzione di stampa preferita',
  SEND_INSTALLATION_INSTRUCTION_KEY:
    "Inviami istruzioni su come effettuare l'installazione",
  SEND_TO_BACK_KEY: 'Porta in secondo piano',
  SEND_KEY: 'Invia',
  SEND_TO_PRINT_TITLE_KEY: 'Invia alla stampa',
  SET_SIZE_KEY: 'Imposta dimensione',
  SETTINGS_KEY: 'Impostazioni',
  SETTINGS_UPPERCASE_KEY: 'IMPOSTAZIONI',
  SHARE_KEY: 'Condividi',
  SIGNED_IN_AS_KEY: 'Accesso effettuato come',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Accedi o registrati per vedere i prezzi personalizzati e i dettagli di pagamento',
  SIGN_UP_NOW_KEY: 'Iscriviti ora',
  SKIP_KEY: 'Ignora',
  SOLID_COLORS_KEY: 'Tinte unite',
  SQFT_UNIT_STRING_KEY: 'piedi quadrati',
  SQM_UNIT_STRING_KEY: 'm²',
  START_TOUR_KEY: 'Inizia il tour',
  STATUS_MSG: 'Il file è stato mandato in stampa.',
  SUBMIT_BUTTON_KEY: 'Sottoscrivi',
  SHARE_LINK_LABEL: 'Seleziona il tipo di collegamento che vuoi condividere',
  SHARE_EDIT_LINK: 'Modifica collegamento',
  SHARE_VIEW_LINK: 'Visualizza collegamento',
  SHARE_YOUR_CREATION: 'Condividi la tua creazione.',
  STREET_ADD: 'indirizzo',
  TARGET_VIEWING_HINT:
    '* La distanza di visione può essere cambiata dalle impostazioni.',
  TERMS1_KEY: 'termini',
  TERMS2_KEY: 'Informativa sulla privacy HP',
  TERMS3_KEY: 'Informativa sui diritti in materia di dati personali di HP',
  TERMS_OF_USE_KEY: "Termini d'uso",
  TERMS_OF_USE: "Termini d'uso.",
  TEXT_SHADOW_COLOR_KEY: "Colore dell'ombreggiatura del testo",
  TEXT_ANCHOR_MIDDLE: 'metà',
  TEXT_UPPERCASE_KEY: 'TESTO',
  TILE_KEY: 'Riquadro',
  TOTAL_KEY: 'TOTALE',
  TOTAL_PRICE_KEY: 'Totale:',
  TRANSPARENCY_KEY: 'Trasparenza',
  TEMPLATES_KEY: 'modelli',
  TEMPLATES_UPPER_CASE_KEY: 'MODELLI',
  THANK_YOU_KEY: 'Grazie',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Sblocca',
  UNGROUP_KEY: 'Annulla raggruppamento',
  UPDATE_TEXT_KEY: 'Aggiorna',
  UPLOAD_KEY: 'Carica',
  UPLOAD_LOGO_KEY: 'Carica logo',
  UPLOAD_IMAGE_KEY: 'Carica la tua immagine',
  UPLOAD_UPPERCASE_KEY: 'CARICA',
  USER_NAME: 'Nome utente',
  USER_TYPE_TITLE_KEY: 'Che tipo di utente sei*',
  UNTILE_KEY: 'Rimuovi riquadri',
  UNSPLASH_SEARCH_TITLE: 'Ricerca Unsplash',
  VALIDITY_KEY: 'Validità',
  VANILLA_LOGIN_DIALOG_KEY:
    'Iscriviti gratuitamente per salvare e stampare il progetto e vedere il tuo lavoro salvato',
  VANILLA_PREVIEW_MESSAGE_KEY:
    "Questa è l'anteprima del tuo progetto. Controlla che sia definitivo prima di procedere o seleziona Modifica per apportare eventuali modifiche",
  VAT_KEY: 'IVA',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vettoriale',
  VIEW_FOTOLIA_KEY: 'Visualizza in Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'Visualizza su Getty Image©', //  View in Getty Image©
  VIEW_I_STOCK_KEY: 'Visualizza su iStock©', // View in iStock©
  VIEW_DESIGN_DETAILS_KEY: 'Visualizza dettagli progetto',
  VIEW_DESIGNER_PROFILE_KEY: 'Visualizza profilo designer',
  VIEW_PRICE_KEY: 'Visualizza prezzo',
  VECTEEZY_SEARCH_TITLE: 'Ricerca Vecteezy',
  WALL_POSTER_KEY: 'Poster',
  WALL_SIZE_TEXT_KEY: 'Dimensioni parete',
  WARNING_KEY: 'Attenzione',
  WEBSITE: 'Sito web',
  WIDTH_KEY: 'Larghezza',
  YOU_CAN_ALWAYS_ACCESS: 'Puoi sempre accedere ai tuoi progetti in ',
  YOUR_NAME_KEY: 'Nome',
  YOUR_SELECTION_WILL_KEY:
    'La selezione diventerà il percorso di stampa predefinito per le stampe future.',
  YOUR_PROJECT_KEY: 'Il tuo progetto:',
  PROJECT_NAME_ERROR_TEXT: 'Inserisci un nome per il progetto.',
  PROJECT_FOLDER_ERROR_TEXT: 'Inserisci un nome per la cartella di progetto.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Impostazioni avviso pixel',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Distanza minima di visione',
  BACKGROUND_UPLOAD_KEY: 'sfondo',
  OBJECT_UPLOAD_KEY: 'oggetto',
  PHOTO_UPLOAD_KEY: 'foto',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Nessun contenuto trovato',
  NO_ELEMENT_ERROR_MESSAGE: 'Nessun elemento trovato.',
  NO_MORE_IMAGES_FOUND_KEY: 'Non sono state trovate altre immagini',
  NO_PATTERN_ERROR_MESSAGE: 'Nessun motivo trovato.',
  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',

  ALREDY_HAVE_AN_ACCOUNT: 'Hai già un a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Cambia in {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Colore esagonale: {0}',
  NEAR_KEY: 'Vicino',
  FAR_KEY: 'Lontano',
  CLOSE_UP_KEY: 'Avvicinamento',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    "Le immagini che stai tentando di utilizzare sono più piccole o più grandi dell'area di disegno che stai utilizzando.",
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    "Per ottenere risultati migliori usa un'immagine a risoluzione 999",
  MESSAGE_KEY: 'Messaggio:',
  VIEWS_KEY: '{0} visualizzazioni',
  COST_DESCRIPTION_MESSAGE_KEY:
    'Questo è il riepilogo del costo relativo al contenuto premium incluso nel tuo progetto. {0} Selezionando Fine, accetti che i fornitori di contenuti ti addebitino il seguente costo.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} è la tua opzione di stampa predefinita,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: 'Non hai ancora un account Dreamstime?',
  REGISTER_PATTERNSUB2:
    ' riceverai $ 100 di immagini ad alta risoluzione {0} per aiutare con tutte le tue esigenze creative!',
  REGISTER_PATTERNSUB3:
    'Iscriviti oggi e nel corso dei prossimi 30 giorni, scarica i file creativi dalla nostra base di contenuti di 25 milioni di foto e guarda come {0} può aiutarti a soddisfare i tuoi bisogni creativi.',
  ZOOM_WARNING_PIXELATED_TEXT:
    "Il livello di ridimensionamento è tale che l'immagine stampata può apparire pixellata quando viene visualizzata a {0} {1} * (la risoluzione di stampa corrente è {2} dpi).",
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    "La distanza di visualizzazione consigliata è {0} {1}. Se non è appropriata, diminuisci la dimensione dell'immagine o la dimensione della parete.",
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    "La dimensione minima consigliata dell'immagine è {0} x {1} pixel.",
  UPLOAD_STATUS: '{0}% di {1}MB',
  REGISTER_TO: 'Registrati a {0}',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MINIMUM_DIMENSIONS_KEY: 'Le dimensioni minime sono {0} (l) per {1} (a).',
  MINIMUM_HEIGHT_KEY: "L'altezza minima è {0}.",
  MINIMUM_WIDTH_KEY: 'La larghezza minima è {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Le dimensioni massime sono {0} (l) per {1} (a).',
  MAXIMUM_WIDTH_KEY: 'La larghezza massima è {0}.',
  MAXIMUM_HEIGHT_KEY: "L'altezza massima è {0}.",
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Inserisci dimensioni numeriche maggiori di zero.',
  PROCESSING_FAILED: 'Elaborazione non riuscita. Riprova più tardi',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'I file PDF a più pagine non sono supportati.',
  MINIMUM_ZOOM_WARNING:
    "Questo sfondo non può essere ulteriormente ridimensionato in quanto si è raggiunta l'altezza o la larghezza minima necessaria per coprire la parete.",
  OF_KEY: 'di',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Spiacenti, i PDF crittografati non sono supportati.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importazione di {0} su {1} file',
  RECOLORING_KEY: 'Ricolorazione in corso...',
  TEXT_COLOR_KEY: 'Colore del testo',
  SOLID_COLOR_KEY: 'Tinta unita',
  AUTHENTICATE_DIALOG_TITLE:
    'Questa origine del contenuto è protetta da password',
  MATERIAL_CHOICE_APPLIED: 'Scelta del materiale applicato.',
  AUTHENTICATE_FAILED_MESSAGE: 'Autenticazione non riuscita.',
  DROPBOX_IMPORT_ERROR_HEADER: "Errore nell'importazione di alcuni file",
  HP_FEEDBACK_TEXT: 'Ci piacerebbe avere tue notizie', // We would love to hear from you
  FEEDBACK_QUERY_TEXT: 'Nel complesso, quanto sei soddisfatto di noi?', // Overall, how satisfied are you with us?
  VERY_SATISFIED_BUTTON_TEXT: 'Molto Soddisfatto', // Very Satisfied
  SATISFIED_BUTTON_TEXT: 'Soddisfatto', // Satisfied
  DISSATISFIED_BUTTON_TEXT: 'Insoddisfatto', // Dissatisfied
  VERY_DISSATISFIED_BUTTON_TEXT: 'Molto Insoddisfatto', // Very Dissatisfied

  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  FEEDBACK_IMPROVE_TEXT: 'Cosa possiamo fare per migliorare?', // What can we do to improve?
  FEEDBACK_PRIVACY_INFO_TEXT: 'Informazzione sulla Privacy', // Privacy Statement

  INSPIRATION_SIZE_CHANGE_WARNING:
    'Questo modello di ispirazione viene fornito con una dimensione predefinita di {0} X {1} {2}. La dimensione della pagina verrà modificata automaticamente per adattarsi a questo modello.',
  FEEDBACK_PLACEHOLDER_TEXT:
    'Esaminiamo la tua risposta per migliorare i nostri prodotti, quindi ti preghiamo di non condividere alcun dato personale o contenuto riservato / propreitario',
  DEFAULT_PROJECT_NAME: 'Progetto',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Scegli il laptop',
  SHOW_ALL_KEY: 'Mostra tutto',
  Go_BACK_KEY: 'Ritorna',
  FIRST_NAME_KEY: 'Nome',
  LAST_NAME_KEY: 'Cognome',
  PHONE_NUMBER_KEY: 'N. telefono',
  POSTAL_ADDRESS: 'Indirizzo postale',
  COMPANY_NAME: "Nome dell'azienda",
  INVALID_PHONE_NUMBER_KEY: 'Numero di telefono non valido',
  INVALID_POSTAL_ADDRESS: 'Indirizzo postale non valido', // Invalid Postal address
  INVALID_COMPANY_NAME: "Nome dell'azienda non valido", // Invalid Comapany name
  TERMS_AND_CONDITIONS: 'Accetto i Termini e condizioni',
  INVOICE_UPLOAD: 'Carica fattura',
  INVOICE_FILE_MISSING: 'File di fattura mancante', // Invoice file missing
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* È possibile trovare informazioni dettagliate sui dati dei principi di raccolta HP su HP', // You can find detailed information about HP’s data collection principles on HP
  PRIVACY_STATEMENT_LINK1: 'Informazzione sulla Privacy', // Privacy Statement
  PERSONAL_INFORMATION_CONDITION:
    'Accetto che i miei dati personali vengano condivisi con HP per ricevere comunicazioni sulle future campagne di HP.*',
  SERVICE_PROVIDER_CONDITION:
    'Accetto che i dati forniti possano essere condivisi con i fornitori di servizi per i fini di stampa e per il processo di consegna.*',
  ORDER_DESIGN: 'Ordina design',
  SUBMIT_YOUR_DESIGN: 'Invia il tuo design',
  SUBMISSION_DESIGN_ORDER: "Invio dell'ordine del design",
  ENTER_REQUIRED_FIELDS_KEY: 'Compilare i campi obbligatori',
  ADDRESS_KEY: 'Indirizzo',
  INVALID_ADDRESS_KEY: 'Indirizzo non valido',
  CITY_KEY: 'Città',
  INVALID_CITY_KEY: 'Città non valida',
  COUNTRY_KEY: 'Paese',
  STATE_KEY: 'Stato',
  ZIP_KEY: 'CAP',
  INVALID_ZIP_KEY: 'CAP non valido',
  ORDER_NUMBER: 'Numero ordine',
  YOUR_DETAILS_KEY: 'I tuoi dettagli',
  APPLY_DESIGN_COMPETITION: 'Partecipa al concorso per il miglior design',
  NOTICE_KEY: 'Avviso:',
  CAUTION_FOR_LAPTOP_SELECTION:
    "Per avere una skin per PC perfettamente adattata alla tua, devi selezionare il modello esatto corrispondente all'acquisto, come indicato nella fattura.",
  RESTART_PROJECT_ALERT_TITLE: 'Riavvia un progetto?',
  DISCARD_ALERT_MESSAGE: 'Il progetto corrente verrà ignorato',
  RESTART: 'Riavvia',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certificato di',
  AUTHENTICITY_STRING: 'autenticità',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Dimensioni pagina Avvertenza!',
  MODIFY_SIZE_WARNING:
    'Se desideri ridimensionare questo disegno, puoi farlo nella scheda "Impostazioni". Gli elementi di design potrebbero richiedere modifiche per adattarsi alle dimensioni desiderate.',
  RANDOMIZE_KEY: 'Rendi casuale',
  PLEASE_WAIT: 'Attendi',
  PROTECTING_YOUR_DATA: 'Stiamo proteggendo i tuoi dati...',
  SEARCH_YOUR_LAPTOP_KEY: 'Cerca il tuo laptop', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Oops! Non è stato possibile trovare laptop per la tua ricerca.', // Google translated

  // new
  LOGIN_ADOBE_STOCK_KEY: 'Accedi ad Adobe Stock',
  ZOOM_IN_KEY: 'Zoom In',
  ZOOM_OUT_KEY: 'Zoom Out',
  VIEW_IN_ADOBE_STOCK_KEY: 'Visualizza su Adobe Stock©',
  ADOBE_STOCK_SEARCH_TITLE: 'Cerca su Adobe Stock',
  HP_MOSAIC_SEARCH_TITLE: 'Mosaico HP',
  SERIAL_NUMBER_KEY: 'Numero di serie',
  LOCKED_PROJECT: 'Progetto bloccato',
  LOCKED_MESSAGE:
    'Il progetto è stato ordinato e non può essere modificato. È possibile solo visualizzare il progetto.',
  EXPIRED_PROJECT: 'Progetto scaduto',
  EXPIRED_MESSAGE: 'Il progetto è scaduto.',
  DELETED_PROJECT: 'Progetto eliminato',
  DELETED_MESSAGE: 'Il progetto è stato eliminato.',
  CHOOSE_GROUP_TYPE: 'Scegli il tipo {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Inserisci numeri maggiori di zero.',
  SIZE_KEY: 'Dimensione',
  DISTANCE_FROM_KEY: 'Distanza da',
  MYROOM_UPPERCASE_KEY: 'LA MIA STANZA',
  FURNITURE_KEY: 'Arredamenti',
  FIXTURES_KEY: 'Strutture',
  ADD_A_WALL_KEY: 'Aggiungi parete',
  SELECT_A_WALL_KEY: 'Seleziona una parete',
  LEFT_KEY: 'Sinistra',
  RIGHT_KEY: 'Destra',
  DELETE_WALL_KEY: 'Elimina parete',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Scegli il tipo di tela',
  MAXIMUM_WALL_SIZE_KEY:
    'La dimensione massima della parete è {0} quadrati.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    "L'altezza della tela supera l'altezza della parete.",
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'La larghezza della tela supera la larghezza della parete.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Il valore massimo delle colonne per la larghezza corrente è {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    "Il numero massimo di righe per l'altezza corrente è {0}",
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'La larghezza della parete è inferiore alla larghezza della tela.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'La parete deve avere una larghezza minima di {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    "La parete deve avere un'altezza minima di {0} {1}.",
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    "L'altezza della parete è inferiore all'altezza della tela.",
  MAXIMUM_WALL_HEIGHT_KEY: "L'altezza massima della parete è {0} {1}.",
  FINISHING_KEY: 'Finitura',
  MIRROR_KEY: 'Specchio',
  NATURAL_KEY: 'Naturale',
  ROWS_KEY: 'Righe',
  COLUMNS_KEY: 'Colonne',
  DEFAULT_WALL_SIZE_KEY: 'Dimensione predefinita della parete',
  EDIT_KEY: 'Modifica',
  TOP_KEY: 'In alto',
  BOTTOM_KEY: 'Fondo'
};
